import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useGlobalController } from "@bcm-dev/bcms-vite";
import TransferReviewPage, { getDefaultPageData } from "components/pages/TransferReviewPage";
import Classes, { Account } from "model";

/**
 * @name CaptureTransfersRecurringReviewTransfer
 * @returns {React.Component}
 * @description The capture component for the review transfers page with the 
 * from, to, amount and description values entered.
 * This capture is used in the following capture groups:
 * "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersRecurringReviewTransfer(props) {
    // Initialize all model classes
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const savingsAccount = Account.getDefaultBrandedAccountByType("savings");
    // Initalize a new instance of BCMSStateManagerCRUD using the default page data
    // updating the from, to, amount and description properties of the transfer
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], checkingAccount)
        .update([ "transfer", "to" ], savingsAccount)
        .update([ "transfer", "amount" ], 100)
        .update([ "transfer", "schedule" ], "Recurring")
        .update([ "transfer", "frequency" ], "Monthly")
        .update([ "transfer", "startDate" ], BCMSDate.init())
        .update([ "transfer", "estimatedDeliveryDate" ], BCMSDate.init())
        .update([ "transfer", "duration" ], "No End Date")
        .update([ "transfer", "description" ], "Sample")
        .submit();

    // Return the TransferReviewPage passing the data variable
    return <TransferReviewPage data={ data } />
}